import { environment } from "src/environments/environment";

export class Util {

  static getUserLocalDateTimeString(date: any, timezoneOffset: number): any {
    let localDate = Util.convertUTCToTimezone(date, timezoneOffset);
    
    const pad = (n: number) => n.toString().padStart(2, '0');

    const year = localDate.getFullYear();
    const month = pad(localDate.getMonth() + 1);
    const day = pad(localDate.getDate());

    let hours = localDate.getHours();
    const minutes = pad(localDate.getMinutes());

    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours === 0 ? 12 : hours; // convert "0" to "12"
    const formattedHours = pad(hours);

    return `${year}-${month}-${day} ${formattedHours}:${minutes} ${ampm}`;
  }

  static convertUTCToTimezone(date: any, timezoneOffset: number): Date {
    const utcDate = new Date(date); // parse as UTC
    const offsetMs = timezoneOffset * 60 * 60 * 1000; // convert hours to ms
    return new Date(utcDate.getTime() + offsetMs);
  }
  
  static toLocalInputValue(date: Date): string {
    const pad = (n: number) => n.toString().padStart(2, '0');

    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1); // JS months are 0-indexed
    const day = pad(date.getDate());

    const hours = pad(date.getHours());
    const minutes = pad(date.getMinutes());

    return `${year}-${month}-${day}T${hours}:${minutes}`;
  }

  static getSubdomain() {
    let location = window.location.hostname;
    // if(environment.preprod){
    //   //at the moment, new-admin is hosted at xxxx.new-admin.preprod.webtest.ng
    //   //we're removing the .preprod so that it doesn't see new-admin as subdomain when no subdomain is specified and the user accesses new-admin.preproe.webtest.ng directly
    //   location = location.replace('.preprod', '');
    // }
    const splitlocation = location.split('.');
    let subdomain;
    if (splitlocation.length >= 2) {
      subdomain = splitlocation[0];
      if (subdomain == 'www' || subdomain == 'admin' || subdomain == 'new-admin') {
        subdomain = '';
      }
    }
    else {
      subdomain = '';
    }
    return subdomain;
  }
  static isQuillEmpty(html: string | null | undefined): boolean {
    if (!html) return true;

    const temp = document.createElement("div");
    temp.innerHTML = html;

    const text = temp.textContent?.trim() || "";
    return text.length === 0;
  }
}